(() => {
  'use strict';
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initSlider = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-neb-slide]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    let paused = reduceMotion() || root.dataset.autoplay !== 'true';
    const counter = root.querySelector('[data-neb-slide-count]');
    const pauseButton = root.querySelector('[data-neb-slide-pause]');
    const paint = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      if (counter) counter.textContent = `${String(current + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!paused && !document.hidden) timer = setInterval(() => paint(current + 1), Math.max(5, Number(root.dataset.seconds) || 7) * 1000);
    };
    root.querySelector('[data-neb-slide-prev]')?.addEventListener('click', () => { paint(current - 1); start(); });
    root.querySelector('[data-neb-slide-next]')?.addEventListener('click', () => { paint(current + 1); start(); });
    pauseButton?.addEventListener('click', () => { paused = !paused; pauseButton.textContent = paused ? '▶' : 'Ⅱ'; pauseButton.setAttribute('aria-pressed', String(paused)); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) start(); });
    root.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); paint(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); paint(current - 1); }
    });
    let touchX = null;
    root.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', event => {
      if (touchX === null) return;
      const delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 55) paint(current + (delta > 0 ? -1 : 1));
      touchX = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', start);
    new MutationObserver(() => { if (!root.isConnected) stop(); }).observe(document.body, { childList: true, subtree: true });
    paint(0);
    start();
  };
  const init = node => node.querySelectorAll('[data-neb-slider]').forEach(initSlider);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.neb-search-open').forEach(masthead => {
      masthead.classList.remove('neb-search-open');
      const toggle = masthead.querySelector('[data-neb-search-toggle]');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    });
  });
})();
